// Composes this app's full string table (shared/i18n/common.js +
// shared/i18n/portal.js — portal never needs shared/i18n/admin.js's
// catalog/cost-management/users/settings/pricing-workspace copy) and
// registers it with shared/i18n/index.js so that file's own `t` resolves
// portal's strings — see shared/i18n/index.js's header comment for why
// registration, not a direct import, is what keeps this app from pulling
// admin's strings into its own bundle (the whole point of this split — see
// PROGRESS.md's "Blocked / needs Ermiyas" entry on the portal bundle
// budget). Imported by context/LanguageContext.jsx, which is itself
// imported early enough (App.jsx's provider tree) that this module's
// top-level registerStrings() call always runs before any component calls
// t().

import { registerStrings, t, LANGUAGES, DEFAULT_LANGUAGE } from 'shared/i18n/index.js';
import commonStrings from 'shared/i18n/common.js';
import portalStrings from 'shared/i18n/portal.js';

registerStrings({ ...commonStrings, ...portalStrings });

export { t, LANGUAGES, DEFAULT_LANGUAGE };
